<template>
    <div>
        <div class="header__mobile--menu-icon">
            <svg v-if="!visible" @click="show" width="27" height="14">
                <use xlink:href="/assets/front/img/sprite.svg#icon-mobile-menu"></use>
            </svg>

            <svg v-if="visible" style="width: 16px" @click="show" width="16" height="16">
                <use xlink:href="/assets/front/img/sprite.svg#icon-close"></use>
            </svg>
        </div>

        <nav class="header__mobile no-select" :class="{ 'header__mobile--active': visible }" @click="hide">
            <div class="header__mobile-wrapper" @click.stop>

                <ul class="header__mobile-sections header__mobile-sections--border-top" itemscope
                    itemtype="https://schema.org/SiteNavigationElement">
                    <li v-for="(section, index) in sections" :key="index" class="header__mobile-section"
                        :class="{ active: section.active }">
                        <div class="header__mobile-section-name-wrapper">
                            <div class="header__mobile-section-name-wrapper--content">
                                <svg class="svgIcon" width="19" height="19">
                                    <use :href="'/assets/front/img/sprite.svg#' + section.icon"></use>
                                </svg>
                                <p class="header__mobile-section-name"
                                    :class="{ 'header__mobile-section-name--active': section.active }"
                                    @click.prevent.stop="(section.active && section.href) ? redirect(section.href) : showSection(section)">
                                    {{ section.name }}
                                </p>
                            </div>
                            <div class="btn header__mobile-section-arrow" :class="{ active: section.active }"
                                @click.stop="showSection(section)">
                                <p>{{ section.active }}</p>
                                <svg v-if="section.active" width="10" height="10">
                                    <use xlink:href="/assets/front/img/sprite.svg#icon-caret-up"></use>
                                </svg>
                                <svg v-if="!section.active" width="10" height="10">
                                    <use xlink:href="/assets/front/img/sprite.svg#icon-caret-b"></use>
                                </svg>
                            </div>
                        </div>

                        <ul class="header__mobile-section-pages" v-if="section.active && section.pages.length">
                            <li class="header__mobile-section-page-wrapper"
                                :class="{ 'header__mobile--create-page': page.href === '/create/tariffs' }"
                                v-for="page in section.pages">
                                <svg v-if="page.href === '/create/tariffs'" width="11" height="11">
                                    <use xlink:href="/assets/front/img/sprite.svg#icon-plus_nav"></use>
                                </svg>
                                <a class="header__mobile-section-page" :href="domain + prefix + page.href" @click="hide"
                                    itemprop="url">
                                    {{ page.name }}
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>

                <ul class="header__mobile-sections" v-if="!render && user">
                    <li class="header__mobile-section">
                        <div class="header__mobile-section-name-wrapper">
                            <p class="header__mobile-section-name">
                                {{ $lang('header.lk') }}
                            </p>

                            <div class="btn header__mobile-section-arrow" :class="{ active: profileActive }"
                                @click.stop="showPersonal">
                                <svg width="12" height="7">
                                    <use xlink:href="/assets/front/img/sprite.svg#icon-caret-b"></use>
                                </svg>
                            </div>
                        </div>
                        <header-profile v-if="profileActive"></header-profile>
                    </li>
                </ul>
                <div />
            </div>
        </nav>
    </div>
</template>

<script>
import HeaderLogoutButton from "./HeaderLogoutButton";
import HeaderLoginButton from "./HeaderLoginButton";
import HeaderLogo from "./HeaderLogo";
import HeaderProfile from "./HeaderProfile";
import HeaderLoginButtonRender from "./HeaderLoginButtonRender";

export default {
    name: 'HeaderNavMobile',
    props: ['sections', 'render', 'partnerLogo'],
    components: {
        HeaderLogoutButton,
        HeaderLoginButton,
        HeaderLoginButtonRender,
        HeaderLogo,
        HeaderProfile
    },
    data() {
        return {
            user: window.laravel.user,
            domain: window.laravel.appUrlByLocale,
            prefix: window.laravel.prefix,
            visible: false,
            profileActive: false
        }
    },
    mounted() {
        this.currentSectionActive()
    },
    methods: {
        show() {
            this.visible = true;
            document.body.style.overflow = 'hidden';
        },
        hide() {
            this.visible = false;

            document.body.style.overflow = '';
        },
        showSection(section) {
            let active = section.active;

            this.hideSections();

            section.active = !active;
        },
        hideSections() {
            this.sections.forEach(section => section.active = false);
            this.profileActive = false;
        },
        showPersonal() {
            this.hideSections();

            this.profileActive = true;
        },
        redirect(href) {
            return location.href = window.laravel.appUrlByLocale + window.laravel.prefix + href;
        },
        currentSectionActive() {
            this.sections.find((item) => item.href === this.$route.path).active = true;
        }
    },
}
</script>

<style scoped>
.svgIcon {
    color: #A9B1C2;
    margin-left: 2rem;

    :hover {
        color: #353D51;
    }
}

.no-select {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
</style>
